export default {
  FILTER_STUDY_PROGRAM_LIST: 'FilterStudyProgramList',
  SORT_STUDY_PROGRAM_LIST: 'SortStudyProgramList',
  LOAD_STUDY_PROGRAM_LIST_START: 'LoadStudyProgramListStart',
  LOAD_STUDY_PROGRAM_LIST_END: 'LoadStudyProgramListEnd',
  SEARCH_STUDY_PROGRAM_LIST_FILTER_STUDY_PROGRAM_START: 'SearchStudyProgramListFilterStudyProgramStart',
  SEARCH_STUDY_PROGRAM_LIST_FILTER_STUDY_PROGRAM_END: 'SearchStudyProgramListFilterStudyProgramEnd'
};